import api from '../api';
import Axios from 'axios';
import { getJwt } from '@app/helpers';
import { trackPromise } from 'react-promise-tracker';

const controller = 'crfADistribuir';

export interface ConsolidadoPluriAnualRelatorioADistribuirResult {
    projetoCodigo: string
    codigoPacote: string
    consolidadoPlurianualConsolidadoPlurianualNomePacote: string
    consolidadoPlurianualADistribuir: number;
    consolidadoPlurianualADistribuirFormat: string;
    numeroLinha: number;
    valorFormatado: string;
    executadoFormatado: string;
    executadoAnosAnterioFormatado: string;
}

export const getRelatorioConsolidadoPlurianualADistribuirMenorQueZero = () => {
    return api.get<ConsolidadoPluriAnualRelatorioADistribuirResult[]>(`crfADistribuir/getRelatorioConsolidadoPlurianualADistribuirMenorQueZero`);
}

export const getAllVerificarPluriAnualDiferenteDeZero = () => {
    return api.get<ConsolidadoPluriAnualRelatorioADistribuirResult[]>(`crfADistribuir/getAllVerificarPluriAnualDiferenteDeZero`);
}



export const exportarVerificarPluriAnualDiferenteDeZero = (nomeDoArquivo: string) => {
    const urlBase = window.location.origin;

    trackPromise(
        Axios.get(`${urlBase}/api/${controller}/exportarVerificarPluriAnualDiferenteDeZero/`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeDoArquivo);
            link.setAttribute('id', 'downloadElementexportarVerificarPluriAnualDiferenteDeZero');
            document.body.appendChild(link);
            link.click();
            var doc = document.getElementById('downloadElementexportarVerificarPluriAnualDiferenteDeZero');

            if (doc) {
                doc.outerHTML = '';
            }
        }),
    );
};



export const exportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero = (nomeDoArquivo: string) => {
    const urlBase = window.location.origin;

    trackPromise(
        Axios.get(`${urlBase}/api/${controller}/exportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero/`, {
            responseType: 'blob',
            headers: {
                Authorization: `Bearer ${getJwt()}`,
            },
        }).then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeDoArquivo);
            link.setAttribute('id', 'downloadElementexportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero');
            document.body.appendChild(link);
            link.click();
            var doc = document.getElementById('downloadElementexportarRelatorioConsolidadoPlurianualCompromissadoMenorQueZero')
            if (doc) {
                doc.outerHTML = '';
            }
        }),
    );
};